import { render } from "./OrderHistoryListSubItem.vue?vue&type=template&id=3c5c9e54"
import script from "./OrderHistoryListSubItem.vue?vue&type=script&lang=js"
export * from "./OrderHistoryListSubItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__